import { Alert, Empty, Image, message, Spin } from 'antd';
import { useEffect, useState } from 'react';

const supportedImageExtension = ['.jpg', '.jpeg', '.png'];

const FilePreviewer = ({ getUrl, file }) => {
  const [sourceUrl, setSourceUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);

  const processSource = async () => {
    if (!file) {
      setFileType(null);
      setSourceUrl(null);
      return;
    }

    setLoading(true);
    try {
      let url = null;
      url = await getUrl(file);

      let detectedType = 'unsupported';
      if (file?.type === 'application/pdf') {
        detectedType = 'pdf';
      } else if (file?.type?.startsWith('image/') || (url && supportedImageExtension.some(ext => url.toLowerCase().split('?')[0].endsWith(ext)))) {
        detectedType = 'image';
      } else if (url && url.toLowerCase().split('?')[0].endsWith('.pdf')) {
        detectedType = 'pdf';
      }

      setFileType(detectedType);
      setSourceUrl(url);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al Obtener la vista previa del documento',
        style: { marginTop: '40vh' },
      });
      setFileType(null);
      setSourceUrl(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    processSource();
  }, [file]);

  return (
    <Spin className="cmt-spin mt-20" spinning={loading}>
      {
        (!fileType && !loading) && <Empty
          description={
            <span style={{ fontSize: 12 }}>
              No hay archivo para previsualizar
            </span>
          }
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          className='mt-20'
        />
      }
      {
        (fileType === 'pdf') && <object
          data={sourceUrl}
          type="application/pdf"
          width="100%"
          height="600px"
          aria-label=' '
          className='mt-20'
        />
      }
      {
        (fileType === 'image') && <Image
          src={sourceUrl}
          alt="Vista previa"
          style={{ maxWidth: '100%', maxHeight: '600px', objectFit: 'contain', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
          className='mt-20'
        />
      }
      {
        (fileType === 'unsupported') && <Alert
          message='El formato del archivo no tiene vista previa disponible.'
          type="warning"
          showIcon
          className='mt-20'
        />
      }
    </Spin>
  );
};

export default FilePreviewer;